import React, { Component } from 'react';

import { Button } from 'components/button';
import { I18n } from 'components/translate';
import { inject, observer } from 'mobx-react';
import {
  DeepSearchService,
  UserSegmentationService
} from 'modules/userManager';
import PropTypes from 'prop-types';

import './DeepSearchFooter.scss';

@inject((stores) => ({
  deepSearchLoading: stores.DeepSearchStore.deepSearchLoading,
  searchDone: stores.DeepSearchStore.searchDone,
  saveDone: stores.DeepSearchStore.saveDone,
  saveLoading: stores.DeepSearchStore.saveLoading
}))
@observer
export default class DeepSearchFooter extends Component {
  static propTypes = {
    deepSearchLoading: PropTypes.bool,
    searchDone: PropTypes.bool,
    onClearFilters: PropTypes.func,
    saveDone: PropTypes.bool,
    saveLoading: PropTypes.bool,
    searchUsers: PropTypes.func,
    hideSegmentationOptions: PropTypes.bool,
    submitButtonLabel: PropTypes.string
  };

  onClick = () =>
    DeepSearchService.deepSearch({ searchUsers: this.props.searchUsers });

  onSave = () => UserSegmentationService.saveSegmentation();

  onDuplicate = () => UserSegmentationService.openDuplicateModal();

  buttonContext(label, loading, done) {
    if (!(loading || done)) {
      return {
        className: 'deep__search__search__button',
        component: <I18n label={label} />
      };
    } else if (loading && !done) {
      return {
        className: 'deep__search__search__button__loading',
        component: (
          <div className="loading">
            <i className="icon icon-loading" />
          </div>
        )
      };
    } else if (!loading && done) {
      return {
        className: 'deep__search__search__button__done',
        component: <i className="icon icon-check" />
      };
    }

    return {};
  }

  renderCleanFiltersButton = () => {
    const { onClearFilters } = this.props;

    return (
      <Button
        className="small deep__search__footer__buttons__clean"
        onClick={onClearFilters}
        size="small"
        type="cancel"
      >
        <I18n label="general.clean_filters" />
      </Button>
    );
  };

  render() {
    const { searchDone, deepSearchLoading, submitButtonLabel } = this.props;

    const buttonLabel = submitButtonLabel
      ? submitButtonLabel
      : 'general.search';

    const searchButton = this.buttonContext(
      buttonLabel,
      deepSearchLoading,
      searchDone
    );

    return (
      <div className="deep__search__footer">
        <div className="deep__search__footer__buttons">
          {this.renderSegmentationOptions()}
          {this.renderCleanFiltersButton()}
          <button
            className="hot-button hot-button--secondary hot-button--sm"
            disabled={deepSearchLoading || searchDone}
            onClick={this.onClick}
          >
            {searchButton.component}
          </button>
        </div>
      </div>
    );
  }

  renderSegmentationOptions = () => {
    const { hideSegmentationOptions } = this.props;
    const { hasSegmentation } = UserSegmentationService;

    if (hideSegmentationOptions) {
      return <div className="deep__search__footer__buttons__segmentation" />;
    } else if (hasSegmentation) {
      return this.renderSegmentationActions();
    } else {
      return this.renderNewSegmentationButton();
    }
  };

  renderNewSegmentationButton = () => (
    <div className="deep__search__footer__buttons__segmentation">
      <button
        className="hot-button hot-button--secondary hot-button--sm"
        onClick={this.onDuplicate}
      >
        <I18n label="users_manager.users_list.header.new_segmentation" />
      </button>
    </div>
  );

  renderSegmentationActions = () => {
    const { saveDone, saveLoading } = this.props;

    const saveButton = this.buttonContext(
      'general.save_changes',
      saveLoading,
      saveDone
    );

    return (
      <div className="deep__search__footer__buttons__segmentation">
        <Button
          outline
          size="small"
          className={saveButton.className}
          disabled={saveLoading || saveDone}
          onClick={this.onSave}
        >
          {saveButton.component}
        </Button>
        <Button
          className="small deep__search__footer__buttons__duplicate"
          onClick={this.onDuplicate}
          size="small"
          type="cancel"
        >
          <I18n label="general.duplicate" />
        </Button>
      </div>
    );
  };
}
